<template>
    <div class="content">
        {{loaddata('')}}
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            output: [],
        }
    },
  methods: {
      loaddata: function(){
          var vue = this;
          axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        axios.get('https://hellehallen.halbooking.dk/infoskaerm.asp?id=5&pid=01',{
            method: 'GET',
            mode: 'no-cors',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            },
            withCredentials: false,
        })
      .then(response => function(){
        var lines = response.split("\n"),i;
        for (i = 0; i < lines.length; i++){
            vue.output.push("<tr><td>"
                            + lines[i].slice(0,-1).split(",").join("</td><td>")
                            + "</td></tr>");
        }
        vue.output = "<table>" + vue.output.join("") + "</table>";
      })
      }
  },    
}
</script>
<style scoped>
body{
    background-color:none;
}
</style>